import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, ShieldCheck, AlertTriangle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// Public landing for a shared "generic" ID verification link.
// Spawns a fresh, private verification for whoever opened it, then redirects them to it.
export default function IDVerifyStart() {
  const { intakeToken } = useParams();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        const { data } = await axios.post(`${API}/api/id-verify/public/intake/${intakeToken}/start`);
        navigate(`/verify/${data.token}`, { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || 'This verification link is no longer active. Please contact your broker for a new one.');
      }
    })();
  }, [intakeToken, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="idverify-start">
      <div className="w-full max-w-sm text-center">
        {!error ? (
          <>
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-900 text-white">
              <ShieldCheck className="h-7 w-7" />
            </div>
            <p className="flex items-center justify-center gap-2 text-sm font-semibold text-slate-700">
              <Loader2 className="h-4 w-4 animate-spin" /> Setting up your secure ID verification…
            </p>
            <p className="mt-1 text-xs text-slate-500">This only takes a moment.</p>
          </>
        ) : (
          <div data-testid="idverify-start-error">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-100 text-rose-600">
              <AlertTriangle className="h-7 w-7" />
            </div>
            <p className="text-sm font-semibold text-slate-800">Link unavailable</p>
            <p className="mt-1 text-xs text-slate-500">{error}</p>
          </div>
        )}
      </div>
    </div>
  );
}
